import { toast } from "sonner";

// types
import { PrincipalFormData } from "components/EditBusinessProfileSections/OrganizationSection/OrganizationSection";

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function isAnyInputEmpty(formData: PrincipalFormData[]) {
  return formData.some((item) => item.name === "" || item.title === "");
}

export function formatCurrentPrincipalsPayload(data) {
  const formattedPayload = data
    .filter((item) => item.name.trim() && item.title.trim()) // Filter out empty entries
    .map((item) => `${item.name.trim()} - ${item.title.trim()}`)
    .join("; "); // Use semicolon-space to match server regex

  return formattedPayload;
}

export function formatNonFedCertPayload(data){
  const formattedPayload = data
    .map((item) => item.name.trim())
    .join("; ")

  return formattedPayload;
}

export function saveErrorToast() {
	toast.error(`Failed to Save`, {
		description: 'Please try again'
	})
}